<template>
  <Teleport to="body">
    <Transition name="zoom">
      <div v-if="popup !== ''" class="popup">
        <div class="popup__inner" :class="{ notice: popup !== 'confirm' && popup !== 'alert' }">
          <div class="popup__header">
            <span />
          </div>
          <div class="popup__body" />
          <div v-if="popup === 'alert' || popup === 'confirm'" class="popup__buttons">
            <a
              v-if="popup !== 'alert'"
              href="javascripts:;"
              class="btn popup__cancel"
              @click="closePopup"
            >
              取消
            </a>
            <a
              href="javascripts:;"
              class="btn popup__ok"
              :class="{ 'btn--single': popup === 'alert' }"
              @click="closePopup"
            >
              確定
            </a>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import usePopup from '@global/composable/usePopup';

const { popup, closePopup } = usePopup();
</script>
